<div id="Interstitial-Placeholder" *ngIf="loadingInterstitialParams">
  <div id="Interstitial-Content">
    <div id="Interstitial-Text">Carregando...</div>
  </div>
</div>

<div
  *ngIf="alertParams"
  [ngClass]="{
    alert: alertParams,
    'alert-success': alertParams.type === 'success',
    'alert-danger': alertParams.type === 'error'
  }"
>
  {{ alertParams.text }}
</div>
